<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <slot name="header">
            &nbsp;
          </slot>
        </div>

        <div class="modal-body text-center">
          <slot name="body">
              <iframe width="560" height="315" style="min-height: 315px; max-width: 100%; max-height: 100%"
                      :src="'https://www.youtube-nocookie.com/embed/' + videoSlug + '?controls=0&rel=0'"
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen></iframe>
          </slot>
        </div>

        <div class="modal-footer">
          <slot name="footer">
            <div class="mb-3">&nbsp;</div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HelpVideoModal',
  props: {
    videoSlug: String
  }
}
</script>

<style>
.modal-footer {
  border-top: unset;
}
#abaco-modal___BV_modal_footer_ {
  padding-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/HelpVideoModal.vue